export const bigPaintCanLiters = 18
export const mediumPaintCanLiters = 3.6
export const smallPaintCanLiters = 2.5
export const extraSmallPaintCanLiters = 0.5